import React from "react";
import PathConstants from "./path-constants";

const AccountOverview = React.lazy(
  () => import("../pages/product/account/account-overview"),
);

const routes = [
  { path: PathConstants.AccountOverview, element: <AccountOverview /> },
];

export default routes;
